import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';

export default ({ type, text }) => (
  <span>
    <LegacyIcon type={type} style={{ marginRight: 8 }} />
    {text}
  </span>
);
